import {CssInstance} from '@superweb/css'
import {LocaleProvider} from '@superweb/intl'
import {AppContainer} from '@superweb/ui'
import {ThemeProvider} from '@yandex-delivery/blocks/theme'
import {Notifications} from '@yandex-delivery/ui'
import React, {Suspense, useState} from 'react'
import {useParams} from 'react-router-dom'

import {useConfig} from '../../config'
import {ExperimentsProvider} from '../../contexts/experiments'
import {useClientHeight} from '../../hooks'
import type {Path} from '../../types'
import {Resource} from '../../utils'
import {ErrorBoundary} from '../ErrorBoundary'
import {Router as RouterDesktop} from '../Routes/RouterDeprecated@desktop'
import {TariffsHeader} from '../TariffsHeader/TariffsHeader@desktop'
import {Loader} from '../ui/Loader'
import styleClasses from './classes@desktop.module.css'
import {getErrorScreenProps} from './utils'

type Props = {
  headerSize?: number
  withHeader?: boolean // True в Тарифах, тк так есть header
  withAppMenu?: boolean // True в ЛК, тк там свой superweb provider с app menu
}

function Tariffs({headerSize = 0, withHeader, withAppMenu}: Props) {
  const {tariffsService} = useConfig()
  const [resource] = useState(() => new Resource(tariffsService.fetchTariffsZones))
  const path = useParams<Path>()
  const clientHeight = useClientHeight()

  return (
    <ExperimentsProvider experiments={{withAppMenu}}>
      <Notifications>
        <ThemeProvider>
          <div
            className={styleClasses.pageWrapper}
            data-page-background="minor"
            style={{height: clientHeight - headerSize}}
          >
            {withHeader && <TariffsHeader />}
            <ErrorBoundary getScreenProps={getErrorScreenProps}>
              <Suspense fallback={<Loader />}>
                <RouterDesktop path={path} resource={resource} />
              </Suspense>
            </ErrorBoundary>
          </div>
        </ThemeProvider>
      </Notifications>
    </ExperimentsProvider>
  )
}

export default function (props: Props) {
  const {lang} = useConfig()

  // Если тарифы рендерятся в аккаунте с appMenu, то там уже есть свой провайдер @superweb,
  // поэтому тут не нужен провайдер @superweb
  if (props.withAppMenu) return <Tariffs {...props} />

  return (
    <LocaleProvider value={lang}>
      <CssInstance>
        <AppContainer>
          <Tariffs {...props} />
        </AppContainer>
      </CssInstance>
    </LocaleProvider>
  )
}
